import React from "react";
import * as styles from "./hr.module.css";

export const Hr = () => <hr className={styles.hr} />
